import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import logo from "../../assets/images/illustration/signIn_page_illustration.png";
import {
  LOGIN_ILLUSTRATION_TITLE1,
  LOGIN_ILLUSTRATION_TITLE2,
  LOGIN_ILLUSTRATION_SUB_TITLE,
} from "../../constants/staticText";
import Button from "@mui/material/Button";
import LearnMore from "./LearnMore";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[2],
    fontSize: 11,
    Padding: 0,
  },
}));

export default function Content() {
  const [open, setOpen] = React.useState(false);
  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };
  return (
    <Box>
      <Stack
        sx={{
          flexDirection: "column",
          alignSelf: "center",
        }}
      >
        <Box>
          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <img src={logo} width="100%" height="100%" alt="" />
          </Box>
        </Box>
        <Box>
          <Stack
            sx={{
              gap: 1,
              justifyContent: "center",
              alignItems: "center",
              padding: 3,
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                justifyContent: "center",
                alignItems: "center",
                fontWeight: "bold",
                padding: 0,
                mb: 0,
                lineHeight: 1,
              }}
            >
              {LOGIN_ILLUSTRATION_TITLE1}
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                justifyContent: "center",
                alignItems: "center",
                fontWeight: "bold",
                padding: 0,
              }}
            >
              {LOGIN_ILLUSTRATION_TITLE2}
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                padding: 0,
                justifyContent: "center",
                alignItems: "center",
                ml: 2,
              }}
            >
              {LOGIN_ILLUSTRATION_SUB_TITLE}
            </Typography>
          </Stack>
        </Box>
        <Box>
          <Stack
            sx={{
              justifyContent: "center",
              alignItems: "center",
              mt: 2,
            }}
          >
            <ClickAwayListener onClickAway={handleTooltipClose}>
              <div>
                <LightTooltip
                  PopperProps={{
                    disablePortal: true,
                  }}
                  onClose={handleTooltipClose}
                  open={open}
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                  title={<LearnMore />}
                  placement="left"
                >
                  <Button
                    variant="outlined"
                    size="small"
                    style={{ textTransform: "none" }}
                    sx={{
                      height: "30px",
                      width: "120px",
                      borderRadius: 15,
                    }}
                    onClick={handleTooltipOpen}
                  >
                    Learn More
                  </Button>
                </LightTooltip>
              </div>
            </ClickAwayListener>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
}
